import e from"styled-components";const i=e.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-self: stretch;
	padding: ${({isTemplate:e})=>e?"0px":"8px"};
	gap: 16px;
	height: 100%;
	box-sizing: border-box;
`,t=e.div`
	display: flex;
	flex-direction: column;
	align-self: stretch;
	gap: 16px;
`,l=e.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 24px;
`,o=e.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`,p=e.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,n=e.div`
	display: flex;
	flex-flow: row;
	align-items: center;
	gap: 4px;
	align-self: stretch;
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"8px":"19px"};
`,a=e.div`
	color: ${({theme:e})=>e.text.title};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"14px":"22px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"17.252px":"25.887px"};

	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`,s=e.div`
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"9px":"14px"};
	font-style: normal;
	font-weight: 500;
	line-height: ${({isTemplate:e})=>e?"11.944px":"18px"};

	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`,x=e.div`
	display: flex;
	align-items: center;
	gap: 6px;
	align-self: stretch;
	color: ${({theme:e})=>e.text.gray};
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};
	padding: ${({isTemplate:e})=>e?"5px":"0px"};

	font-style: normal;
	font-weight: 500;
	line-height: 19px; /* 158.333% */
`,f=e.div`
	display: flex;
	align-items: center;
	gap: 8px;
	color: #adadad;
	font-family: 'SF Pro Display';
	font-size: ${({isTemplate:e})=>e?"8px":"13px"};
	font-style: normal;
	font-weight: 500;
	line-height: 19px; /* 158.333% */
`,r=e.div`
	display: flex;
	align-items: center;
	gap: 4px;
`;export{i as CardContent,t as CardContentContainer,p as CardMiddleContent,l as CardTopContent,s as Description,f as LikesAndComments,r as LikesAndCommentsWrapper,x as ModifiedWrapper,n as SpaceAndAuthor,a as Title,o as TitleWrapper};
